import React from 'react';
import {
	Bot,
	CalendarClock,
	MessagesSquare,
	MousePointer2,
	Radar,
	Store,
} from 'lucide-react';

const features = [
	{
		icon: Store,
		title: 'Free Online Store',
		copy: 'Create a professional online storefront in minutes. Showcase your services, products, pricing, and availability from one place.',
	},
	{
		icon: Radar,
		title: 'Reach Local Communities',
		copy: 'Choose the neighborhoods and communities you want to serve. Get discovered by customers looking for businesses near them.',
	},
	{
		icon: MessagesSquare,
		title: 'AI-Powered Customer Support',
		copy: 'Answer questions instantly, provide information, and engage customers even when you are busy.',
	},
	{
		icon: CalendarClock,
		title: 'Automated Booking & Scheduling',
		copy: 'Let customers book appointments and services directly into your calendar without phone calls or back-and-forth messages.',
	},
	{
		icon: Bot,
		title: 'AI Marketing Campaigns',
		copy: 'Create promotions, social media content, and local marketing campaigns automatically.',
	},
	{
		icon: MousePointer2,
		title: 'Smart Customer Targeting',
		copy: 'Reach the right customers at the right time with automated campaigns designed to generate more bookings and sales.',
	},
];

function Features() {
	return (
		<section className='landing-section landing-features' id='features'>
			<div className='landing-section__intro' data-reveal>
				<p className='landing-eyebrow'>Everything You Need to Grow Locally</p>
				<h2>One operating layer for storefront, community reach, bookings, and AI marketing.</h2>
				<p>
					Launch your store, reach nearby customers, answer questions, and turn
					local demand into scheduled work without adding more tools.
				</p>
			</div>

			<div className='landing-features__grid'>
				{features.map((feature, index) => {
					const Icon = feature.icon;
					return (
						<article className='landing-feature-card' key={feature.title} data-reveal>
							<div className='landing-feature-card__icon'>
								<Icon size={22} aria-hidden='true' />
							</div>
							<span>{String(index + 1).padStart(2, '0')}</span>
							<h3>{feature.title}</h3>
							<p>{feature.copy}</p>
						</article>
					);
				})}
			</div>
		</section>
	);
}

export default Features;
